<template>
  <div v-if="isValidArray(categories)" class="categories">
    <span v-for="category in categories" :key="category.value">
      <CarCategory
        :data="category"
        :disabled="category.percentage === 0"
        tooltip
      />
    </span>
  </div>
</template>

<script>
import { isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import CarCategory from 'components/CarCategory'

export default {
  name: 'Categories',
  props: {
    categories: {
      type: Array
    }
  },
  components: {
    CarCategory
  },
  methods: {
    isValidArray (val) {
      return isValidArray(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.categories {
  margin-top: 16px;
  padding: 12px 16px 0;
  position: relative;
  text-align: center;

  &:before {
    background-color: $gray-2;
    content: '';
    height: 1px;
    left: -16px;
    position: absolute;
    right: -16px;
    top: -1px;
  }
}
</style>
